import { componentUtils } from '@ardoq/scope-data';
import { type EnhancedScopeData } from '@ardoq/data-model';
import { nodesComponentIds, nodesReferenceIds } from '@ardoq/dependency-map';
import type { ViewLoadMetrics } from 'tracking/durationTracking/types';

type NodesInput = Parameters<typeof nodesComponentIds>[0];

export const getPerformanceTrackingData = (
  nodes: NodesInput,
  scopeData: EnhancedScopeData
): ViewLoadMetrics => {
  const componentIds = new Set<string>();
  for (const id of nodesComponentIds(nodes)) {
    componentIds.add(id);
  }

  const referenceIds = new Set<string>();
  for (const id of nodesReferenceIds(nodes)) {
    referenceIds.add(id);
  }

  const workspaceIds = new Set<string>();
  for (const componentId of componentIds) {
    const workspaceId = componentUtils.getWorkspaceId(scopeData, componentId);
    if (workspaceId) {
      workspaceIds.add(workspaceId);
    }
  }

  return {
    componentCount: componentIds.size,
    referenceCount: referenceIds.size,
    workspaceCount: workspaceIds.size,
  };
};
